import { VISCOSITY_UNIT_OPTIONS, ViscosityDisplayUnit } from "../viscosity/definitions";

export const DISPLAY_UNIT_OPTIONS = {
  flow: ["m3/h", "m3/min", "L/s", "L/min", "gpm"],
  head: ["m", "ft"],
  power: ["kW", "hp"],
  npshr: ["m", "ft"],
  diameter: ["mm", "in"],
  viscosity: VISCOSITY_UNIT_OPTIONS,
  efficiency: ["%"],
} as const;

export type FlowDisplayUnit = typeof DISPLAY_UNIT_OPTIONS.flow[number];
export type HeadDisplayUnit = typeof DISPLAY_UNIT_OPTIONS.head[number];
export type PowerDisplayUnit = typeof DISPLAY_UNIT_OPTIONS.power[number];
export type NpshrDisplayUnit = typeof DISPLAY_UNIT_OPTIONS.npshr[number];
export type DiameterDisplayUnit = typeof DISPLAY_UNIT_OPTIONS.diameter[number];
export type EfficiencyDisplayUnit = typeof DISPLAY_UNIT_OPTIONS.efficiency[number];

export interface DisplayUnits {
  flow: FlowDisplayUnit;
  head: HeadDisplayUnit;
  power: PowerDisplayUnit;
  npshr: NpshrDisplayUnit;
  diameter: DiameterDisplayUnit;
  viscosity: ViscosityDisplayUnit;
  efficiency: EfficiencyDisplayUnit;
}

export type DisplayUnitMetric = keyof DisplayUnits;

export const DISPLAY_UNIT_DEFAULTS: DisplayUnits = {
  flow: "m3/h",
  head: "m",
  power: "kW",
  npshr: "m",
  diameter: "mm",
  viscosity: "cSt",
  efficiency: "%",
};

export const DISPLAY_UNIT_QUERY_KEYS: Record<Exclude<DisplayUnitMetric, "efficiency">, string> = {
  flow: "flowUnit",
  head: "headUnit",
  power: "powerUnit",
  npshr: "npshrUnit",
  diameter: "diameterUnit",
  viscosity: "viscosityUnit",
};

export const DISPLAY_UNIT_LABELS = {
  flow: {
    "m3/h": "m³/h",
    "m3/min": "m³/min",
    "L/s": "L/s",
    "L/min": "L/min",
    gpm: "gpm",
  },
  head: {
    m: "m",
    ft: "ft",
  },
  power: {
    kW: "kW",
    hp: "hp",
  },
  npshr: {
    m: "m",
    ft: "ft",
  },
  diameter: {
    mm: "mm",
    in: "inch",
  },
  viscosity: {
    cP: "cP",
    cSt: "cSt",
    "mPa·s": "mPa·s",
    "Pa·s": "Pa·s",
  },
  efficiency: {
    "%": "%",
  },
} as const;

export const DISPLAY_UNIT_TITLES: Record<Exclude<DisplayUnitMetric, "efficiency">, string> = {
  flow: "Flow",
  head: "Head",
  power: "Power",
  npshr: "NPSHr",
  diameter: "Diameter",
  viscosity: "Viscosity",
};
